import { Link } from 'react-router-dom';
import { siteInfo, categories, hotTags } from '@/mocks/site';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-fire-line text-base text-background-50"></i>
              </span>
              <span className="text-base font-bold font-heading">{siteInfo.name}</span>
            </div>
            <p className="text-sm text-foreground-300 leading-relaxed">
              {siteInfo.slogan}
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold font-heading mb-4">热门分类</h4>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold font-heading mb-4">热门标签</h4>
            <div className="flex flex-wrap gap-2">
              {hotTags.map((tag) => (
                <span
                  key={tag}
                  className="px-3 py-1 text-xs rounded-full bg-foreground-800 text-foreground-300 whitespace-nowrap"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold font-heading mb-4">关于我们</h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/about"
                  className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  品牌介绍
                </Link>
              </li>
              <li>
                <a
                  href={`mailto:${siteInfo.email}`}
                  className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer"
                  rel="nofollow"
                >
                  联系我们
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-foreground-800">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-400">
              &copy; {siteInfo.year} {siteInfo.name} 版权所有 | 本站内容仅供娱乐参考
            </p>
            <p className="text-xs text-foreground-400">
              黑料吃瓜网 | 91黑料吃瓜网 | 黑料吃瓜不打烊
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}